"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiLink16 = {
    paths: [
        {
            path: 'M5.99998946,0 C6.55228475,0 7,0.44771525 7,1 C7,1.55228475 6.55228475,2 6,2 L3.99965217,2 C2.89527477,2 2,2.89527477 2,3.99965217 C2,5.10402957 2.89527477,5.99930434 3.99965217,5.99930434 L5.99998946,5.99930434 C6.55228475,6 7,6.44771525 7,7 C7,7.55228475 6.55228475,8 6,8 L5.98113272,7.99982558 L5.98113272,7.99982558 L3.99965217,7.99930434 C1.79070527,7.99930434 0,6.20859907 0,3.99965217 C0,1.79070527 1.79070527,0 3.99965217,0 L5.99998946,0 Z M12.0003478,0.000695657851 C14.2092947,0.000695657851 16,1.79140093 16,4.00034783 C16,6.20929473 14.2092947,8 12.0003478,8 L10.0000105,8 C9.44771525,8 9,7.55228475 9,7 C9,6.44771525 9.44771525,6 10,6 L12.0003478,6 C13.1047252,6 14,5.10472523 14,4.00034783 C14,2.89597043 13.1047252,2.00069566 12.0003478,2.00069566 L10.0000105,2.00069566 C9.44771525,2 9,1.55228475 9,1 C9,0.44771525 9.44771525,0 10,0 L12.0003478,0.000695657851 Z M11.0029699,3 C11.5142826,3 11.9356987,3.38272018 11.9932922,3.88266744 L12,4 C12,4.55228475 11.5469637,5 11.0029699,5 L4.99703014,5 C4.4463856,5 4,4.55613518 4,4 C4,3.44771525 4.45303631,3 4.99703014,3 L11.0029699,3 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Link',
    width: 16,
    height: 8,
};
var muiLink24 = {
    paths: [
        {
            path: 'M13,8 L9,8 C9.55228475,8 10,8.44771525 10,9 C10,9.55228475 9.55228475,10 9,10 L4.99214053,10 C2.23505745,10 0,7.75580481 0,5 C0,2.23857625 2.23054698,0 4.99214053,0 L9,0 C9.55228475,0 10,0.44771525 10,1 C10,1.55228475 9.55228475,2 9,2 L5,2 C3.34314575,2 2,3.34314575 2,5 C2,6.65685425 3.34314575,8 5,8 L17,8 C18.6568542,8 20,6.65685425 20,5 C20,3.34314575 18.6568542,2 17,2 L13,2 C12.4477153,2 12,1.55228475 12,1 C12,0.44771525 12.4477153,0 13,0 L17.0078595,0 C19.7649426,0 22,2.24419519 22,5 C22,7.76142375 19.769453,10 17.0078595,10 L13,10 C12.4477153,10 12,9.55228475 12,9 C12,8.44771525 12.4477153,8 13,8 Z M5,4 L17,4 C17.5522847,4 18,4.44771525 18,5 C18,5.55228475 17.5522847,6 17,6 L5,6 C4.44771525,6 4,5.55228475 4,5 C4,4.44771525 4.44771525,4 5,4 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Link',
    width: 22,
    height: 10,
};
var muiLink = {
    base: muiLink16,
    smIcon: muiLink16,
    lgIcon: muiLink24,
};
exports.muiLink = muiLink;
//# sourceMappingURL=link.js.map